import { Chart } from "primereact/chart";
import { useEffect, useState } from "react";
import { IStudentGradeViewLarge } from "../../../../models/student/studentGradeDetail";
import ChartDataLabels from "chartjs-plugin-datalabels";

const GradeDistributionModal = (props: IStudentGradeViewLarge) => {
  const { showModal, studentGrade } = props;
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    if (studentGrade) {
      setChartData({
        labels: studentGrade?.map((student) => student.grade),
        datasets: [
          {
            data: studentGrade?.map((student) => student.percentage),
            backgroundColor : ["rgb(250, 151, 29)", "rgb(250, 115, 97)", "rgb(181, 82, 82)", "rgb(92, 126, 126)"],
            hoverOffset: 10,
          },
        ],
      });
    }
  }, [studentGrade]);

  const options = {
    cutout: "60%",
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          padding: 20,
        },
        onClick: null,
      },
      datalabels: {
        align: "center",
        color: "white",
        font: {
          weight: "bold",
          size: 14,
        },
        formatter: (value: number) => {
          return `${value}%`;
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            return tooltipItem.label;
          },
          title: function () {
            return "";
          },
        },
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "white",
        bodyColor: "white",
        displayColors: false,
        position: "average",
        caretPadding: 20,
        yAlign: "bottom",
      },
    },
    elements: {
      arc: {
        borderWidth: 2,
        borderColor: "white",
        borderRadius: 10,
      },
    },
  };

  return (
    <>
      <div className="modal-header">
        <h1 className="modal-title fs-5">Grade Distribution</h1>
        <button
          type="button"
          className="btn-close"
          onClick={() => showModal(false)}
        ></button>
      </div>
      <div className="modal-body">
        <div className="gardedistribution card border-0">
          <Chart
            type="doughnut"
            data={chartData}
            options={options}
            className=""
            width="275"
            plugins={[ChartDataLabels]}
          />
        </div>
      </div>
      <div className="modal-footer mb-2">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => showModal(false)}
        >
          Cancel
        </button>
      </div>
    </>
  );
};

export default GradeDistributionModal;
